import Link from "next/link";
import { useState, type FC } from "react";
import {
  type Cadence,
  type TierMembershipOptionType as TierMembershipOptionDef,
} from "~/types";
import { Price } from "../Price";
import { CadenceOptions } from "./CadenceOptions";

type Props = {
  tier: TierMembershipOptionDef;
};

export const TierMembershipOption = ({ tier }: Props) => {
  const [cadence, setCadence] = useState<Cadence>(tier.cadences[1] as Cadence);

  if (!cadence) return <div className="loading loading-dots loading-lg"></div>;

  return (
    <div
      key={tier.id}
      className="mb-7 flex flex-1 flex-col items-center justify-between rounded-xl border border-base-200 bg-base-100 p-5 text-center shadow-lg dark:border-slate-600 dark:shadow-slate-600"
    >
      <div className="top">
        <CadenceOptions
          cadences={tier.cadences}
          selectedCadence={cadence}
          onSelect={setCadence}
        />
        <p className="mb-2 mt-0 text-3xl font-bold dark:text-white">
          {tier.name}
        </p>
        <PriceAndDiscount cadence={cadence} />
        <Features features={tier.features} />
      </div>
      <Link
        className="btn w-60"
        href={`/plans/checkout?plan=${tier.id}&cadence=${cadence.id}`}
      >
        Sign up for {tier?.name} {cadence?.metaData.name}
      </Link>
    </div>
  );
};

const PriceAndDiscount: FC<{ cadence: Cadence }> = ({ cadence }) => (
  <p>
    <Price price={cadence.price.afterDiscount} />{" "}
    <strong>{cadence?.metaData.name}</strong>
    <br />
    {cadence.price.discount > 0 && (
      <span>
        (Save <Price price={cadence.price.discount} />
        !)
      </span>
    )}
  </p>
);

const Features = ({ features }: { features: string[] }) => (
  <div className="mb-5 flex flex-col items-center">
    {features.map((f) => (
      <div className="mb-3" key={f}>
        <span>&#10003;</span> <span>{f}</span>
      </div>
    ))}
  </div>
);

export default Price;
